import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  SelectableHTMLElement,
  SelectableType,
  SelectedEvent,
} from '../../types';
import { IChecklistModule } from './../../models/checklist-module';
import { TranslatePipe } from 'src/packages/shared-ui';

@Component({
  selector: 'ch-module',
  templateUrl: './ch-module.component.html',
  styleUrls: ['./ch-module.component.scss'],
  providers: [TranslatePipe],
})
export class ChModuleComponent {
  @Input() module!: IChecklistModule;
  @Output() selected: EventEmitter<SelectedEvent> =
    new EventEmitter<SelectedEvent>();

  constructor(private readonly translatePipe: TranslatePipe<IChecklistModule>) {}

  /** Titel in der aktuellen App-Sprache, Fallback auf den Basistitel. */
  get displayTitle(): string {
    return this.translatePipe.transform(this.module, 'title');
  }

  select(
    htmlElement: SelectableHTMLElement,
    selected: SelectableType,
    ev: Event
  ) {
    ev.stopPropagation();
    this.selected.emit({
      htmlElement,
      item: selected,
      clickEvent: ev,
    });
  }
}
